import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'

const PaymentsEmpty = () => (
  <Fragment>
    <Heading small>No Payments found for this week</Heading>
    <p>We could not find any payments attached to this care booking</p>
  </Fragment>
)

export default PaymentsEmpty



// WEBPACK FOOTER //
// ./src/payments/details/views/empty.jsx